import { Navbar } from '@met/react-components';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const TopNav = styled(Navbar)`
  ul {
    margin: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  height: 60px;
  border-top: 1px solid #e4eaec;
  padding: 20px;
  z-index: 109;
  font-size: 0.875rem;
  justify-content: center;
  background-color: white;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
`;

export const Content = styled.div`
  min-height: calc(100vh - 84px);
`;

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 84px;
  height: 100%;
  min-height: 100%;
  animation: ${fadeIn} 300ms ease-in-out;
  transition: transform 0.3s;
  flex: 1 0 auto;

  * {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

export const InnerContent = styled.div`
  flex: 1 0 auto;
  margin-top: 1rem;
  max-width: 100%;
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  overflow: hidden;
`;
